<template>
  <BaseModal col-md="col-md-6" offset="3" :subtitulo="tabSelect === 'info' ? 'Informações do modelo' : 'Editar modelo'"
             :modalColor="tabSelect === 'info' ? 'border-primary bg-success' : 'border-warning bg-warning'">
    <template v-slot:modalContent>
      <div class="tabs-container">
        <ul class="nav nav-tabs">
          <li v-if="tabSelect === 'info'">
            <a class="nav-link" :class="tabSelect === 'info' ? 'active' : ''" data-toggle="tab" href="#tab-1"
               id="imgTabs">Imagens</a>
          </li>
          <li v-if="tabSelect === 'info'">
            <a class="nav-link" data-toggle="tab" href="#tab-2" id="docTabs">Documentos</a>
          </li>
          <li v-if="tabSelect === 'editar'">
            <a class="nav-link" :class="tabSelect === 'editar' ? 'active' : ''" data-toggle="tab" href="#tab-3"
               id="editarTabs">Editar modelo</a>
          </li>
        </ul>
        <div class="tab-content">
          <div v-if="tabSelect === 'info'" id="tab-1" class="tab-pane" :class="tabSelect === 'info' ? 'active' : ''">
            <div class="panel-body">
              <ImagensModelo
                  :itemKey="itemKey"
                  @fechar="$emit('fechar')"
              />
            </div>
          </div>
          <div v-if="tabSelect === 'info'" id="tab-2" class="tab-pane">
            <div class="panel-body">
              <DocumentosModelo
                  :itemKey="itemKey"
                  @fechar="$emit('fechar')"
              />
            </div>
          </div>
          <div v-if="tabSelect === 'editar'" id="tab-3" class="tab-pane" :class="tabSelect === 'editar' ? 'active' : ''">
            <div class="panel-body">
              <EditarModelo
                  :itemKey="itemKey"
                  @fechar="$emit('fechar')"
                  @atualizarDados="$emit('atualizarDados', $event)"
              />
            </div>
          </div>
        </div>
      </div>
    </template>
  </BaseModal>
</template>

<script>
import BaseModal from '@/components/base/BaseModal.vue';
import EditarModelo from './EditarModelo.vue';
import ImagensModelo from './ImagensModelo.vue';
import DocumentosModelo from './DocumentosModelo.vue';

export default {
  name: "TabsModalImovel",
  components: {
    BaseModal,
    EditarModelo,
    ImagensModelo,
    DocumentosModelo,
  },
  props: {
    itemKey: String,
    tabSelect: String,
  },
  emits: ["fechar", "atualizarDados"],
};
</script>
